export const LOCATION_UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function isLocationUuid(id: string): boolean {
  return LOCATION_UUID_RE.test(id.trim());
}

export type OrgLocationPickRow = {
  id: string;
  name: string;
  location_code?: string | null;
  city?: string | null;
};

function normalizeToken(s: string): string {
  return s.trim().toLowerCase().replace(/[^a-z0-9]+/g, "");
}

function configKeyToLocationCode(configId: string): string {
  return configId.trim().replace(/^lot_/, "").replace(/_/g, "-");
}

function configKeyToCitySlug(configId: string): string | null {
  const trimmed = configId.trim();
  if (!trimmed.startsWith("lot_")) return null;
  return normalizeToken(trimmed.slice(4).replace(/_/g, " "));
}

/**
 * Map a profile / lead config key (`lot_ravenel`) or UUID to a
 * `public.locations.id` UUID for ops surfaces that require FK-shaped ids.
 */
export function resolveSellerLocationUuid(
  hint: string | null | undefined,
  orgLocations: readonly OrgLocationPickRow[],
): string | null {
  const raw = (hint ?? "").trim();
  if (!raw) return orgLocations[0]?.id ?? null;

  if (isLocationUuid(raw)) {
    return orgLocations.some((l) => l.id === raw) ? raw : null;
  }

  const code = configKeyToLocationCode(raw);
  const codeNorm = normalizeToken(code);
  const citySlug = configKeyToCitySlug(raw);

  for (const loc of orgLocations) {
    const locCode = (loc.location_code ?? "").trim();
    if (locCode && (locCode === code || normalizeToken(locCode) === codeNorm)) {
      return loc.id;
    }
    const nameNorm = normalizeToken(loc.name ?? "");
    const cityNorm = normalizeToken(loc.city ?? "");
    if (citySlug && (nameNorm.includes(citySlug) || cityNorm === citySlug)) {
      return loc.id;
    }
  }

  return null;
}
